import { useTranslation } from 'react-i18next';

import { Table } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';
import { IFiltersProps } from 'coreOld/types';
import { IJob } from 'jobsOld/types';

interface IProps extends IFiltersProps {
  data: IJob[];
  tableColumns;
  filters: Record<string, any>;
  isLoading?: boolean;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage;
}

const RequestJobsTableView = ({
  data,
  tableColumns,
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Table
      data={data}
      columns={tableColumns}
      name={TableNames.SUPPORT_REQUEST_JOB_LIST}
      noItemsFoundText={t('messageNoJobsFound')}
      isLoading={isLoading}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
      alternating={false}
      borderBottom
      hasFilters
    />
  );
};

export default RequestJobsTableView;
